import { clearSStorage, getSStorageInfo, setSStorageInfo } from './utils'

const isDev = process.env.NODE_ENV !== 'production'

/**
 * 转化对象到qs
 * */
export const objectToQueryString = (obj: any) => {
  if (!obj || typeof obj !== 'object') {
    return ''
  }

  const arr: string[] = []
  Object.keys(obj).forEach(key => {
    const val = obj[key]
    arr.push(`${key}=${val}`)
  })
  return arr.length ? `${arr.join('&')}` : ''
}

/**
 * 获取跳转链接
 * */
export const getUrl = (url: string, query: any = {}) => {
  const href = isAllUrl(url)
    ? url
    : `/${isDev ? '' : 'third-open-accounts/'}${url}${isDev ? '' : '.html'}`
  const qs = objectToQueryString(query)
  const qp: any = getQueryParams()
  let info = ''
  // 入口来源
  if (qp?.source && qp.source !== 'undefined') {
    info += `source=${qp.source || getSStorageInfo('source')}`
  }
  // 产品id：京东投顾会携带
  if (qp?.productId && qp.productId !== 'undefined') {
    info += `&productId=${qp.productId || getSStorageInfo('productId')}`
  }
  // 分支机构编号：京东投顾会携带
  if (qp?.salesDepartment && qp.salesDepartment !== 'undefined') {
    info += `&salesDepartment=${qp.salesDepartment || getSStorageInfo('salesDepartment')}`
  }
  // 手机号
  if (qp?.mobilephone && qp.mobilephone !== 'undefined') {
    info = `${info}&mobilephone=${qp.mobilephone}`
  }

  return `${href}#/?${info}&${qs}`
}

export function isAllUrl(url: string) {
  if (url.includes('http') || url.includes('https')) {
    return true
  } else {
    return false
  }
}

/**
 * 根据当前环境切换跳转目标地址
 * */
export default (url: string, query: any = {}) => {
  clearSStorage('lastPage')
  setSStorageInfo('lastPage', window.location.pathname)
  clearSStorage('isBack')
  setSStorageInfo('isBack', query.isBack)
  console.log(getUrl(url, query))

  window.location.href = getUrl(url, query)
  // window.open(getUrl(url, query))
}

interface numberKeyObj {
  [key: number]: any
}

/**
 * 获取url参数
 * */
export function getQueryParams() {
  const url = window.location.href.replace('#/', '')
  const arr = url.split('?')
  const str = arr.length > 1 ? arr[1] : ''
  const result: numberKeyObj = {}

  if (!str) {
    return {}
  }
  return str.split('&').reduce((current, next) => {
    if (next.includes('=')) {
      const objArr: string[] = next.split('=')
      current[<any>objArr[<any>0]] = objArr[1]
    }
    return current
  }, result)
}
